export default __webpack_public_path__ + "img/16310303c4a4439241bf31021f4bdd50.png";